// extracted by mini-css-extract-plugin
module.exports = {"feeds-wrapper":"feedspost_feeds-wrapper__1-Rrh","space-y":"feedspost_space-y__2WvW1","more-btn":"feedspost_more-btn__2u5sK"};